module.exports = __webpack_public_path__ + "img/icon-fleet.e62672d1.svg";